import api from '../instance';
import { ApiResponse } from '@/types/common';
import {
  ProjectUser,
  ProjectUserFilterParams,
  ProjectUserListResponse,
  UpdateProjectUser,
} from '@/types/systemprojectuser.types';

const API_URL = '/project-managers';

export const projectSystemUserService = {
  async getAll(params?: ProjectUserFilterParams): Promise<ProjectUserListResponse> {
    const { data } = await api.projectApi.get<ProjectUserListResponse>(API_URL, { params });
    return data;
  },

  async update(id: number, payload: UpdateProjectUser): Promise<ApiResponse<ProjectUser>> {
    const { data } = await api.projectApi.put<ApiResponse<ProjectUser>>(
      `${API_URL}/${id}`,
      payload,
    );
    return data;
  },

  async toggleStatus(id: number): Promise<ApiResponse<ProjectUser>> {
    const { data } = await api.projectApi.put<ApiResponse<ProjectUser>>(
      `${API_URL}/${id}/toggle-status`,
    );
    return data;
  },

  async remove(id: number): Promise<ApiResponse<void>> {
    const { data } = await api.projectApi.delete<ApiResponse<void>>(`${API_URL}/${id}`);
    return data;
  },

  async export(): Promise<Blob> {
    const res = await api.projectApi.get(`${API_URL}/bulk-export`, {
      responseType: 'blob',
    });
    return res.data;
  },
};
